// src/components/FloatingButtons.jsx
import React, { useState, useEffect } from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa'; // Importing icons
import '../css/FloatingButtons.css'; // Link to the new CSS file

const FloatingButtons = () => {
    // Array of colors for the call button's dynamic background
    const colors = [
        '#007bff', // Blue (primary)
        '#28a745', // Green (success)
        '#6f42c1', // Purple
        '#fd7e14', // Orange
        '#17a2b8'  // Info blue
    ];
    const [currentColorIndex, setCurrentColorIndex] = useState(0);

    useEffect(() => {
        // Set up an interval to change the color every 3 seconds
        const intervalId = setInterval(() => {
            setCurrentColorIndex(prevIndex => (prevIndex + 1) % colors.length);
        }, 3000); // Change color every 3 seconds

        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []); // Empty dependency array means this runs once on mount and cleans up on unmount

    // Dynamically apply the background color
    const callButtonStyle = {
        backgroundColor: colors[currentColorIndex],
        transition: 'background-color 1s ease-in-out' // Smooth transition between colors
    };

    return (
        <div className="floating-buttons-container">
            {/* Call Button */}
            <a href="tel:+918879779777" className="floating-button call-button" style={callButtonStyle}>
                <FaPhoneAlt className="button-icon" />
                {/* Removed: <span className="button-text">Call Us</span> */}
            </a>

            {/* WhatsApp Button */}
            <a href="https://wa.me/918879779777" target="_blank" rel="noopener noreferrer" className="floating-button whatsapp-button">
                <FaWhatsapp className="button-icon" />
                {/* Removed: <span className="button-text">WhatsApp</span> */}
            </a>
        </div>
    );
};

export default FloatingButtons;